<template>
  <v-menu :position-x="position.x" :position-y="position.y" v-model="menu" :close-on-content-click="false" :close-on-click="closeOnClick" :nudge-width="nudgeWidth" offset-x>
    <v-card>
      <v-card-title class="title py-3" v-html="params.title" />
      <v-divider />
      <v-card-text v-html="params.text" />
      <v-card-actions>
        <v-spacer />
        <v-btn :color="params.color || 'error'" :outline="outline" @click="submit()">
          <v-icon v-if="params.icon" class="mr-2">{{ params.icon }}</v-icon>
          {{ params.confirmText }}
        </v-btn>
        <!-- May give an error on pressing cancel, can ignore-->
        <v-btn color="secondary" outline @click="close()" v-html="params.cancelText" />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      position: {
        type: Object,
        default: () => ({
          x: 0,
          y: 0,
        }),
      },
      nudgeWidth: {
        type: Number,
        default: 300,
      },
      outline: {
        type: Boolean,
        default: true,
      },
      closeOnClick: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        menu: false,
        params: {},
        initialParams: {
          title: null,
          text: null,
          confirmText: null,
          cancelText: null,
          color: null,
          icon: null,
        },
        promise: null,
      }
    },
    watch: {
      // May not catch a close outside of pressing "cancel" otherwise
      menu(value) {
        if (!value) {
          if (this.promise) this.promise.resolve(false)
          this.reset()
        }
      },
    },
    methods: {
      close() {
        this.menu = false
      },
      submit() {
        if (this.promise) this.promise.resolve(true)
        this.close()
      },
      show(params) {
        this.reset()
        this.params = {
          ...this.params,
          ...params,
        }

        this.menu = true
        let result = new Promise((resolve, reject) => {
          this.promise = {
            resolve,
            reject,
          }
        })

        return result
      },
      reset() {
        if (this.promise) {
          this.promise.reject('Promise cancelled')
        }

        this.promise = null
        this.params = JSON.parse(JSON.stringify(this.initialParams))
      },
    },
    created() {
      this.reset()
    },
  }
</script>